import { useContext } from 'react'

import { RoomContext } from '../context/roomContext'

export const useRoomContext = () => {
	const context = useContext(RoomContext)
	if (!context) throw new Error('Only use inside Room Context!')
	return context
}
